import './Header.scss'
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {IconPhone} from "../../assets/icons/IconPhone";
import useWindowSize from "../../hooks/use-window-size";
import LogoImage from '../../assets/images/ShinControl_white_en.png'
import useLanguage from "../../hooks/useLanguage";
import {LanguageEnum} from "../../enums/language.enum";

export const Header = () => {

    const {t} = useTranslation()
    const {changeLanguage} = useLanguage()
    const windowSize = useWindowSize()
    const [headerScroll, setHeaderScroll] = useState<boolean>(false)
    const [isOpenMenu, setIsOpenMenu] = useState(false)
    const menuList = [
        {title: t('menu-item-1'), id: 'about'},
        {title: t('menu-item-2'), id: 'advantages'},
        {title: t('menu-item-3'), id: 'services'},
        {title: t('menu-item-4'), id: 'gallery'},
    ]
    const handleScroll = () => {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 200) {
                setHeaderScroll(true)
            } else {
                setHeaderScroll(false)
            }
        })
    }

    useEffect(() => {
        handleScroll()
    }, [])


    const handleClick = (elementId: string) => {
        const element = document.getElementById(elementId)
        if (element) {
            let headerOffset = 100;
            let elementPosition = element.getBoundingClientRect().top;
            let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }

    const handleClickMenu = (title: string) => {
        handleClick(title)
        if (window.innerWidth <= 991) {
            setIsOpenMenu(false)
            document.body.classList.toggle('G-hidden')
        }
    }

    const handleClose = () => {
        setIsOpenMenu(false)
        document.body.classList.remove('G-hidden')
    }


    return <header className={`${headerScroll ? 'header-scroll' : ''}`}>
        <div className="G-container">
            <div className="header-main G-align-center G-justify-between">
                <div className="header-logo" onClick={() => {
                    handleClickMenu('about')
                    document.body.classList.remove('G-hidden')
                }}>
                    <img src={LogoImage} loading={"lazy"} alt="logo"/>
                </div>

                <div className={`header-menu ${isOpenMenu ? 'open-menu' : ''}`}>
                    <ul className=" G-align-center">
                        {menuList.map((item, index) => {
                            return <li onClick={() => handleClickMenu(item.id)} className='header-menu-item'
                                       key={index}>{t(item.title)}</li>
                        })}
                    </ul>
                    {windowSize.width && windowSize.width <= 767 ? <ul className=" G-align-center mobile-languages">
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.english])
                            handleClose()
                        }}>EN
                        </li>
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.russian])
                            handleClose()

                        }}>RU
                        </li>
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.armenian])
                            handleClose()

                        }}>HY
                        </li>
                    </ul> : null}
                </div>

                <div className="header-lang G-align-center">
                    <a className='header-phone G-flex' href={'tel:+374099364333'}>
                        <IconPhone/>
                    </a>
                    {windowSize.width && windowSize.width > 767 ? <ul className=" G-align-center">
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.english])
                        }}>EN
                        </li>
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.russian])

                        }}>RU
                        </li>
                        <li className="header-lang-item" onClick={() => {
                            changeLanguage(LanguageEnum[LanguageEnum.armenian])

                        }}>HY
                        </li>
                    </ul> : null}
                    <div className={`toggle-menu ${isOpenMenu ? 'open-burger' : ''}`}
                         onClick={() => {
                             setIsOpenMenu(!isOpenMenu)
                             document.body.classList.toggle('G-hidden')
                         }}>
                        <span/>
                        <span/>
                    </div>
                </div>
                {windowSize.width && windowSize.width <= 991 ?
                    <div onClick={handleClose} className={`header-bg ${isOpenMenu ? 'active-bg' : ''}`}/> : null}
            </div>
        </div>
    </header>
}
